module.exports = __webpack_public_path__ + "img/pneus-monte-rayon-jantes.2d410738.png";